import React from 'react';
import { getTreatmentDetailByAppointmentId } from 'api/treatment';
import { IVideoTreatmentDetail } from 'types/treatment';

const useTreatmentAppointmentDetail = (id?: number): [IVideoTreatmentDetail | undefined, boolean, (appointmentId: number) => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<IVideoTreatmentDetail>();
    const fetchData = async (appointmentId: number) => {
        if (loading || !appointmentId) return;
        try {
            setLoading(true);
            const result = await getTreatmentDetailByAppointmentId(appointmentId);
            if (!result.error) {
                const resData = result?.data?.data || undefined;
                console.log('resData', resData);
                setData(resData);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (id) {
            fetchData(id);
        }
    }, [id]);

    return [data, loading, fetchData];
};

export default useTreatmentAppointmentDetail;
